import React from 'react';
import Flagship from '../../core/flagship';
import SingleRecordEditField from './SingleRecordEditField';
import { Table, Loader, Button, Header } from 'semantic-ui-react';
import {setAsyncRouteLeaveHook} from '../../utils/helpers';

class SingleRecordEdit extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getRecordFields = this.getRecordFields.bind(this);
        this.state = {
            recordFields: [],
            fieldData: [],
        }
    }

    componentWillMount() {
        setAsyncRouteLeaveHook(this.props.router, this.props.route, this.routerWillLeave.bind(this));
        this.getRecordFields();
    }

    routerWillLeave(url) {
        let modified = this.props.modified;
        let showLeaveConfirmation = this.props.showLeaveConfirmation;
        return new Promise((resolve) => {
            if (!modified) {
                // No unsaved changes -- leave
                resolve(true)
            } else {
                // Unsaved changes -- ask for confirmation
                showLeaveConfirmation(url);

                resolve(false);
            }
        })
    }

    getRecordFields() {
        let self = this;

        Flagship.get(
            "fields/" + this.props.route.type,
            {
                active: true,
                sideload: self.props.recordId
            },
            function(response) {
                if (response.data.success === true) {

                    self.setState(
                        {
                            recordFields: response.data.results
                        }
                    );
                }
            }, function(err) {
                Flagship.error("Error getting fields to edit record: " + err, self.props.recordId, self.props.userId);
            }
        );
    }

    onChange(e, value, i) {
        this.props.editModeChange(e, value, i);
    }

    onChangeName(e, value) {
        this.props.onChangeName(e, value);
    }

    onChangeExtra(e, value, which) {
        this.props.onChangeExtra(e, value, which);
    }

    render() {
        if( typeof this.props.recordData === "undefined") {
            return (
                <Table className="fade-in">
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell colSpan="5">
                                <Loader className="flagship-loader" active inline='centered' />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            );
        } else {

            let self = this;
            let ioService;

            if (this.props.route.type === "io") {

                let found = Flagship.config.lineItemServices.find(function(element) {
                    return element.value === self.props.recordData.record.extra3;
                });
                if (typeof found !== "undefined" && found.hasOwnProperty("text")) {
                    ioService = found.text;
                }
            }

            return (
                <div className="fade-in">
                    {this.props.route.type === "io" ? <Header as="h3" content={ioService} />: null}

                    <SingleRecordEditField
                        addError={self.props.addError}
                        clearError={self.props.clearError}
                        recordId={self.props.recordData.record.id}
                        key={'field-name'}
                        id="recordName"
                        label={this.props.route.niceName + ' Name'}
                        field_value={this.props.name}
                        onChange={(e, value) => self.onChangeName(e, value)}
                    />

                    <SingleRecordEditField
                        addError={self.props.addError}
                        clearError={self.props.clearError}
                        recordId={self.props.recordData.record.id}
                        key={'field-extra1'}
                        id="recordExtra1"
                        {...Flagship.config.records[this.props.route.type].extra1}
                        field_value={this.props.extra1}
                        onChange={(e, value) => self.onChangeExtra(e, value, "extra1")}
                    />

                    <SingleRecordEditField
                        addError={self.props.addError}
                        clearError={self.props.clearError}
                        recordId={self.props.recordData.record.id}
                        key={'field-extra2'}
                        id="recordExtra2"
                        {...Flagship.config.records[this.props.route.type].extra2}
                        field_value={this.props.extra2}
                        onChange={(e, value) => self.onChangeExtra(e, value, "extra2")}
                    />


                    <SingleRecordEditField
                        addError={self.props.addError}
                        clearError={self.props.clearError}
                        recordId={self.props.recordData.record.id}
                        key={'field-extra3'}
                        id="recordExtra3"
                        {...Flagship.config.records[this.props.route.type].extra3}
                        field_value={this.props.extra3}
                        onChange={(e, value) => self.onChangeExtra(e, value, "extra3")}
                    />


                    {this.state.recordFields.map(function(item, i) {

                        return(

                            <SingleRecordEditField
                                addError={self.props.addError}
                                clearError={self.props.clearError}
                                recordId={self.props.recordData.record.id}
                                key={'field-' + i}
                                index={i}
                                onChange={(e, value) => self.onChange(e, value, item)}
                                {...item} />
                        );
                    })}

                    <Button disabled={self.props.requiredMissing || self.props.errors.length ? true : false}
                            primary onClick={self.props.saveAndExit}
                            content="Save Changes"
                    />
                </div>
            );

        }
    }
}

export default SingleRecordEdit;


// WEBPACK FOOTER //
// ./src/components/records/SingleRecordEdit.js